import PageInfo from 'components/common/custom-components/PageInfo';
import React from 'react';
import Listing from './components/Listing';

const SeoProjects = () => {
  return (
    <>
      <PageInfo slug="seo-projects" />
      <Listing />
    </>
  );
};

export default SeoProjects;
